module.exports = __webpack_public_path__ + "static/media/me3_ECAP_University_Icon.cffe9196.svg";